import { useCallback, useEffect, useState } from "react";
import { http } from "../services/http";
import { coordinatorOptions } from "../domain/projects";

export function useProjectCoordinators(enabled) {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(enabled);
  const [error, setError] = useState(null);
  const [retryToken, setRetryToken] = useState(0);

  const retry = useCallback(() => setRetryToken((token) => token + 1), []);

  useEffect(() => {
    if (!enabled) return undefined;

    const controller = new AbortController();

    setLoading(true);
    setError(null);

    http
      .get("/project-coordinators", { signal: controller.signal })
      .then((response) => {
        if (controller.signal.aborted) return;
        setOptions(coordinatorOptions(response.data?.data));
        setLoading(false);
      })
      .catch((requestError) => {
        if (controller.signal.aborted) return;
        setError(requestError);
        setLoading(false);
      });

    return () => controller.abort();
  }, [enabled, retryToken]);

  return { options, loading, error, retry };
}
